// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const eelektross: PokeData = {
  "id": 604,
  "name": "eelektross",
  "height": 21,
  "weight": 805,
  "base_experience": 232,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "headbutt",
    "thrash",
    "acid",
    "zap-cannon",
    "crunch",
    "crush-claw",
    "gastro-acid",
    "discharge",
    "coil",
    "wild-charge",
    "ion-deluge"
  ],
  "moves": [
    "headbutt",
    "acid",
    "zap-cannon",
    "crunch",
    "wild-charge",
    "thunder",
    "thunder-fang",
    "thunder-shock",
    "volt-switch",
    "thunderbolt",
    "quick-tempo",
    "electric-wrath",
    "electric-terrain"
  ],
  "evolution_chain": {
    "id": 306,
    "item": null,
    "species": [
      {
        "name": "tynamo",
        "order": 603,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "eelektrik",
        "order": 604,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 602,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 39,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "eelektross",
        "order": 605,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 603,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "thunder-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 81,
    "ability_power": 186
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
